import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { EaSwapProductSliderModelService } from '../ea-swap-product/ea-swap-product-slider-model.service';
import { LoaderService } from './../../../../../services/infrastructure/loader.service';
import { CommonService } from '../../../../../services/common/common.service';
import { EaSwapDealerOrderItemVM } from '../../../../../models/EASwapDealerOrderItemVM';
import { DealerService } from './../../../../../services/seed/dealer.service';
import { FilterOption } from '../../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../../common/components/filter/filter-enum';
import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../../common/constants/master-constants';
import { FilterComponent } from '../../../../../common/components/filter/filter.component';
import { BroadcastService } from '../../../../../services/infrastructure/broadcaster.service';
import { Router } from '@angular/router';
import { ConfigService } from '../../../../../services/infrastructure/config.service';

@Component({
  selector: 'app-ea-swap-product',
  templateUrl: './ea-swap-product.component.html',
  styleUrls: ['./ea-swap-product.component.scss']
})
export class EaSwapProductComponent implements OnInit, AfterViewInit {
  private subscription = new Array<Subscription>();
  eaSwapProductDS: any[];
  displayColumns: string[] = ['productName', 'seedSize', 'packageSize', 'treatment', 'dealerUnits', 'eaUnits', 'swapEaUnits'];
  selectedValue: string;
  fromProduct: EaSwapDealerOrderItemVM = null;
  fromProductList: EaSwapDealerOrderItemVM[] = [];
  accountNo: number;
  dealerOrderId: number;
  companyCode: string;
  cropYear: number;
  totalItems: number;
  counter = 0;
  noError = true;
  isShowPreviousBtn = false;
  isShowNextBtn = false;
  isShowUpdateBtn = false;
  itemId: number;
  changeListDS: EaSwapDealerOrderItemVM[];
  eaSwapFilters: any;
  totalSum = 0;
  filterOptionsData: Array<FilterOption>;
  isDisplayEAEligibleUnitsChecked: boolean = true;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  index = 0;
  globalKey = { 'Key': 'EaSwapModify', 'Values': [] };
  sendData = false;
  @ViewChild('eaSwapFilter') filterComponent: FilterComponent;

  constructor(
    private eaSwapProductSliderModelService: EaSwapProductSliderModelService,
    private loaderService: LoaderService,
    public commonService: CommonService,
    private dealerService: DealerService,
    private localStorageService: LocalStorageService,
    private broadcastService: BroadcastService,
    private router: Router,
    private configService: ConfigService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    // removed all modify related saved data
    this.globalKey.Values = [];
    localStorage.setItem(this.globalKey.Key, JSON.stringify(this.globalKey.Values));
    this.isShowPreviousBtn = false;
    this.dealerOrderId = this.dealerService.selectedDealerOrderId;
    this.subscription.push(this.eaSwapProductSliderModelService.initializeProductChangeValue.subscribe(x => {
      this.accountNo = x.accountNo;
      this.companyCode = x.companyCode;
      this.cropYear = x.cropYear;

      if (!this.dealerOrderId) {
        this.dealerOrderId = x.dealerData && x.dealerData.length > 0 ? x.dealerData[0].dealerOrderID : 0;
      }

      const dataList = x.dealerData;
      dataList.forEach(x => {
        this.fromProductList.push({
          isSelected: true,
          growerOrderID: 0,
          growerOrderItemId: 0,
          growerGLN: '',
          growerGMK: 0,
          shipToAccount: x.shipToAccount,
          desiredDeliveryDate: new Date(),
          createTimeStamp: x.createdTimestamp,
          updateTimeStamp: x.updatedTimestamp,
          itemID: x.itemID,
          brand: x.brand,
          itemNumber: x.itemNumber,
          dealerOrderItemId: x.dealerOrderItemId,
          dealerOrderNumber: x.dealerOrderNumber,
          growerOrderNumber: '',
          lineNumber: x.lineNumber,
          itemDescription: x.itemDescription,
          seedSize: x.seedSize,
          treatment: x.treatment,
          maturity: x.maturity,
          technology: x.technology,
          productLine: x.productLine,
          marketingBrand: x.marketingBrand,
          packageSize: x.packageSize,
          customerPO: '',
          status: 'Y',
          conv: x.conv,
          seedAvailability: x.seedAvailability,
          geu: x.modifiableUnit,
          netGEU: x.netGEU,
          netBEU: x.netBEU,
          sellerID: 0,
          myDealerBucketQty: x.myDealerBucketQty,
          longShortPosition: x.longShortPosition,
          highlightPackage: x.highlightPackage,
          highlightTreatment: x.highlightTreatment,
          highlightTechnology: x.highlightTechnology,
          errorFlag: false,
          softCommitUnits: x.softCommitUnits,
          plannedUnits: x.plannedUnits,
          shippedUnits: x.shippedUnits,
          errors: [],
          primaryUOM: x.primaryUOM,
          secondaryUOM: x.secondaryUOM,
          ChangeType: x.ChangeType,
          cutCancelOverDate: x.cutCancelOverDate,
          cutOverDate: x.cutOverDate,
          cutOverWarning: x.cutOverWarning,
          showCutOverWarning: false,
          stockTransferUnits: x.stockTransferUnits,
          seedNonReturnable: x.seedNonReturnable,
          eaModifiableUnits: x.eaModifiableUnits,
          dealerUnits: x.dealerUnits
        });
      });

      this.totalItems = this.fromProductList.length;
      this.fromProduct = null;
      this.MoveToNextItem();
      this.eaSwapProductSliderModelService.initializeProductChangeValue.observers = [];
    }));
    this.setFilterData();
  }

  setFilterData() {
    this.filterOptionsData = [
      {
        label: 'Product Name',
        key: 'productName',
        controlType: ControlType.Text,
      },
      {
        label: 'Marketing Brand',
        key: 'marketingBrand',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Seed Size',
        key: 'seedSize',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Package Size',
        key: 'packageSize',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Treatment',
        key: 'treatment',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      },
      {
        label: 'Product Line',
        key: 'productLine',
        controlType: ControlType.DropDown,
        controlDataBindLabel: 'value',
        controlDataBindValue: 'id',
      }
    ];

    this.setFilterDropDownData();
  }

  setFilterDropDownData() {
    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'marketingBrand').controlData = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'seedSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'packageSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    //// Technology master data
    //if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
    //  this.filterOptionsData.find((x) => x.key == 'technology').controlData = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    //}

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'treatment').controlData = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    //// Maturity master data
    //if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
    //  this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    //}

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.filterOptionsData.find((x) => x.key == 'productLine').controlData = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
  }

  // Search Action
  filterSearchClick(event) {
    this.eaSwapFilters = event;
    this.isDisplayEAEligibleUnitsChecked = false;
    this.getDealerOrderToItems();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.eaSwapFilters = event;
    this.getDealerOrderToItems();
  }

  // resetFilter
  resetFilter() {
    this.filterComponent.clearAllFilterWithoutEmit();
  }

  // Move forward
  MoveToNextItem(action = '') {
    if (action == 'click') {
      const errors = (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) ? this.eaSwapProductDS.filter(x => (x.lineErrors && x.lineErrors.errors.length > 0)) : [];
      this.noError = errors && errors.length > 0 ? false : true;
      if (this.noError) {
        var itemIds = new Array<number>();
        itemIds.push(this.itemId)
        var data = {
          itemIdList: itemIds,
          accountNumber: this.accountNo,
          cropYear: this.cropYear,
          companyCode: this.companyCode
        }
        this.loaderService.setLoaderStatus(true);
        this.subscription.push(this.dealerService.getFromEaModifiableUnits(data)
          .subscribe(result => {
            this.fromProduct.eaModifiableUnits = result[0].eaModifiableUnits;
            if (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) {
              this.eaSwapProductDS.forEach(item => {
                if (item.swapEAUnits > 0) {
                  this.validateLineItem(item);
                }
              });
            }
            this.getToNextItem(action);
          }, (error => {
            this.loaderService.setLoaderStatus(false);
          })));
      }
    }
    else {
      this.getToNextItem();
    }
  }

  getToNextItem(action = '') {
    const errors = (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) ? this.eaSwapProductDS.filter(x => (x.lineErrors && x.lineErrors.errors.length > 0)) : [];
    this.noError = errors && errors.length > 0 ? false : true;
    if (this.noError) {
      this.saveInLocalStorage();
      if (this.counter < this.fromProductList.length) {
        if (action == 'click') {
          this.resetFilter();
        }
        this.fromProduct = this.fromProductList[this.counter];
        this.itemId = this.fromProduct.itemID;
        this.counter = this.counter + 1;
        this.getDealerOrderToItems();
      }
      else {
        this.loaderService.setLoaderStatus(false);
      }
      if (this.counter == this.fromProductList.length) {
        this.isShowNextBtn = false;
        this.isShowUpdateBtn = true;
      }
      else {
        this.isShowNextBtn = true;
      }
      if (this.counter > 1) {
        this.isShowPreviousBtn = true;
      }
    }
    else {
      this.loaderService.setLoaderStatus(false);
    }
  }

  MoveToPreviousItem() {
    const errors = (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) ? this.eaSwapProductDS.filter(x => (x.lineErrors && x.lineErrors.errors.length > 0)) : [];
    this.noError = errors && errors.length > 0 ? false : true;
    if (this.noError) {
      var itemIds = new Array<number>();
      itemIds.push(this.itemId)
      var data = {
        itemIdList: itemIds,
        accountNumber: this.accountNo,
        cropYear: this.cropYear,
        companyCode: this.companyCode
      }
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.dealerService.getFromEaModifiableUnits(data)
        .subscribe(result => {
          this.fromProduct.eaModifiableUnits = result[0].eaModifiableUnits;
          if (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) {
            this.eaSwapProductDS.forEach(item => {
              if (item.swapEAUnits > 0) {
                this.validateLineItem(item);
              }
            });
          }
          this.goToPreviousItem();
        }, (error => {
          this.loaderService.setLoaderStatus(false);
        })));
    }
  }

  goToPreviousItem() {
    const errors = (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) ? this.eaSwapProductDS.filter(x => (x.lineErrors && x.lineErrors.errors.length > 0)) : [];
    this.noError = errors && errors.length > 0 ? false : true;
    if (this.noError) {
      this.saveInLocalStorage();
      this.counter = this.counter - 1;
      if (this.counter >= 0) {
        this.resetFilter();
        this.fromProduct = this.fromProductList[this.counter - 1];
        this.itemId = this.fromProduct.itemID;
        // this.counter = this.counter - 1;
        this.getDealerOrderToItems();
      }
      else {
        this.loaderService.setLoaderStatus(false);
      }
      if (this.counter == this.fromProductList.length) {
        this.isShowNextBtn = false;
        this.isShowUpdateBtn = true;
      }
      else {
        this.isShowNextBtn = true;
        this.isShowUpdateBtn = false;
      }
      if (this.counter > 1) {
        this.isShowPreviousBtn = true;
      }
      else {
        this.isShowPreviousBtn = false;
      }
      if (this.counter == 0) {
        ++this.counter;
      }
    }
    else {
      this.loaderService.setLoaderStatus(false);
    }
  }

  // save In Local Storage
  saveInLocalStorage() {
    const data = this.eaSwapProductDS && this.eaSwapProductDS.length > 0 ? this.eaSwapProductDS.filter(x => x.swapEAUnits > 0) : [];
    if (this.fromProduct && data.length > 0) {
      // to get key
      const key = this.getKey();
      // let totalQty = 0;
      // data.forEach(x => totalQty = (+totalQty) + (+x.geu));
      // this.fromProduct.geu = (+(this.fromProduct.netBEU) + +(this.fromProduct.softCommitUnits) + +(this.fromProduct.plannedUnits) + +(this.fromProduct.shippedUnits)) - (+totalQty);

      const value = {
        id: key,
        fromProduct: this.fromProduct,
        ProductList: data
      };
      const storageData = JSON.parse(localStorage.getItem('EaSwapModify'));
      // to remove existing record from local storage
      if (storageData) {
        const index = storageData.indexOf(x => x.id == key);
        if (index != -1) {
          storageData.splice(index, 1);
        }
      }
      // to push updated record in local storage
      if (this.globalKey.Values && this.globalKey.Values.length > 0) {
        this.globalKey.Values = this.globalKey.Values.filter(x => x.id != key);
      }
      this.globalKey.Values.push(value);
      localStorage.setItem(this.globalKey.Key, JSON.stringify(this.globalKey.Values));
      this.sendData = true;
    }
    else if (this.fromProduct) {
      // to get key
      const key = this.getKey();

      this.globalKey.Values = this.globalKey.Values.filter(x => x.id != key);
    }
  }

  // to update modify items with existing local storage data
  updateExistingValue(changedList) {
    if (changedList && changedList.length > 0) {
      let existingChangeList: any[];

      const data = JSON.parse(localStorage.getItem('EaSwapModify'));
      if (data) {
        // To get existing data if exist in local storage
        const dataKey = this.getKey();
        const changeList = data.find(x => x.id == dataKey);
        if (changeList) {
          existingChangeList = changeList.ProductList;
        }
      }
      // apply existing data value
      if (existingChangeList && existingChangeList.length > 0) {
        changedList.forEach(x => {
          const item = existingChangeList.find(y => y.itemID == x.itemID);
          if (item) {
            x.swapEAUnits = item.swapEAUnits;
          }
        });
      }
    }
  }

  // To get unique key to get/set value in local storage
  getKey() {
    return this.fromProduct.dealerOrderItemId.toString() + this.fromProduct.itemNumber;
  }

  loadDealerToItems(event) {
    if (event.checked) {
      this.isDisplayEAEligibleUnitsChecked = true;
    }
    else {
      this.isDisplayEAEligibleUnitsChecked = false;
    }
    this.getDealerOrderToItems();
  }

  getDealerOrderToItems() {
    this.loaderService.setLoaderStatus(true);
    var postData = {
      itemId: this.itemId,
      shipToAccount: this.accountNo,
      companyCode: this.companyCode,
      cropYear: this.cropYear,
      productLine: this.eaSwapFilters ? this.eaSwapFilters.productLine : '',
      packageSize: this.eaSwapFilters ? this.eaSwapFilters.packageSize : '',
      seedSize: this.eaSwapFilters ? this.eaSwapFilters.seedSize : '',
      marketingBrand: this.eaSwapFilters ? this.eaSwapFilters.marketingBrand : '',
      //technology: this.eaSwapFilters.technology,
      treatment: this.eaSwapFilters ? this.eaSwapFilters.treatment : '',
      productName: this.eaSwapFilters ? this.eaSwapFilters.productName : '',
      displayEAEligibleUnits: this.isDisplayEAEligibleUnitsChecked
    };
    this.subscription.push(this.dealerService.getDealerOrderToItems(postData)
      .subscribe(result => {
        if (result != null && result.length > 0) {
          result.map(x => {
            x['lineErrors'] = new LineError();
            return x;
          });
        }
        this.eaSwapProductDS = result
        if (this.eaSwapProductDS) {
          this.updateExistingValue(this.eaSwapProductDS);
          this.eaSwapProductDS.sort((a, b) => (a.swapEAUnits > b.swapEAUnits ? -1 : (a.swapEAUnits < b.swapEAUnits ? 1 : 0))
            || a.brand.toLowerCase().localeCompare(b.brand.toLowerCase())
            || a.seedSize.toLowerCase().localeCompare(b.seedSize.toLowerCase())
            || a.treatment.toLowerCase().localeCompare(b.treatment.toLowerCase())
            || a.packageSize.toLowerCase().localeCompare(b.packageSize.toLowerCase()));
        }
        this.totalSum = 0;
        this.validateCurrentDS();
      }, (error => {
        this.loaderService.setLoaderStatus(false);
      })));
  }

  validateCurrentDS() {
    if (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) {
      var itemIds = new Array<number>();
      itemIds.push(this.itemId)
      var data = {
        itemIdList: itemIds,
        accountNumber: this.accountNo,
        cropYear: this.cropYear,
        companyCode: this.companyCode
      }
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.dealerService.getFromEaModifiableUnits(data)
        .subscribe(result => {
          this.fromProduct.eaModifiableUnits = result[0].eaModifiableUnits;
          this.eaSwapProductDS.filter(x => x.swapEAUnits > 0).forEach(item => {
            this.validateLineItem(item);
          });
          this.loaderService.setLoaderStatus(false);
        }, (error => {
          this.loaderService.setLoaderStatus(false);
        })));
    }
    else {
      this.loaderService.setLoaderStatus(false);
    }
  }

  // Dealer unit change and validation
  dealerUnitChange(action: string, productItem: any) {
    if (!productItem.swapEAUnits) {
      productItem.swapEAUnits = 0;
    }
    if (action == 'decrease') {
      const decValue = +productItem.swapEAUnits - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.swapEAUnits;
        productItem.swapEAUnits = Math.floor(productItem.swapEAUnits / +productItem.conv) * +productItem.conv;
        if (valueBeforeDec == productItem.swapEAUnits) {
          productItem.swapEAUnits = (+productItem.swapEAUnits > +productItem.conv ? +productItem.swapEAUnits - +productItem.conv : 0);
        }
      }
      else {
        productItem.swapEAUnits = 0;
      }
    }
    else {
      var valueBeforeInc = productItem.swapEAUnits;
      productItem.swapEAUnits = Math.ceil(productItem.swapEAUnits / +productItem.conv) * +productItem.conv;
      if (valueBeforeInc == productItem.swapEAUnits) {
        productItem.swapEAUnits = (+productItem.swapEAUnits + +productItem.conv);
      }
    }

    this.validateLineItem(productItem);

    //this.eaSwapProductDS.filter(x => x.lineErrors.errors.length > 0).forEach(item => {
    //  this.validateLineItem(item);
    //});
  }

  // update order
  updateOrder() {
    this.saveInLocalStorage();
    if (this.globalKey && this.globalKey.Values && this.globalKey.Values.length > 0) {
      var itemIds = new Array<number>();
      var eaFromToSwapItems = new Array();
      this.globalKey.Values.forEach(item => {
        itemIds.push(item.fromProduct.itemID);
        var totalSwapUnits = 0;
        item.ProductList.forEach(x => { totalSwapUnits += +x.swapEAUnits; });

        eaFromToSwapItems.push({ itemId: item.fromProduct.itemID, itemDescription: item.fromProduct.itemDescription, brand: item.fromProduct.brand, marketingBrand: item.fromProduct.marketingBrand, netSwapEAUnits: totalSwapUnits, itemNumber: item.fromProduct.itemNumber });
      });
      var data = {
        itemIdList: itemIds,
        accountNumber: this.accountNo,
        cropYear: this.cropYear,
        companyCode: this.companyCode
      }
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.dealerService.getFromEaModifiableUnits(data)
        .subscribe(result => {
          if (result && result.length > 0) {
            var strErrorMessage = '';
            result.forEach(x => {
              if (x.itemId == this.fromProduct.itemID) {
                this.fromProduct.eaModifiableUnits = x.eaModifiableUnits;
                if (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) {
                  this.eaSwapProductDS.forEach(item => {
                    if (item.swapEAUnits > 0) {
                      this.validateLineItem(item);
                    }
                  });
                }
                const errors = (this.eaSwapProductDS && this.eaSwapProductDS.length > 0) ? this.eaSwapProductDS.filter(x => (x.lineErrors && x.lineErrors.errors.length > 0)) : [];
                if (errors && errors.length > 0) {
                  strErrorMessage = strErrorMessage != '' ? strErrorMessage + ', ' + this.fromProduct.itemNumber + ' ' + this.fromProduct.itemDescription : this.fromProduct.itemNumber + ' ' + this.fromProduct.itemDescription;
                }
              }
              else {
                var swapItems = eaFromToSwapItems.filter(si => si.itemId == x.itemId)[0];
                if (swapItems) {
                  if (swapItems.netSwapEAUnits > x.eaModifiableUnits) {
                    strErrorMessage = strErrorMessage != '' ? strErrorMessage + ', ' + swapItems.itemNumber + ' ' + swapItems.itemDescription : swapItems.itemNumber + ' ' + swapItems.itemDescription;
                  }
                }
              }
            });

            if (strErrorMessage != '') {
              strErrorMessage = 'Swap EA Units should be Less/Equal to the EA Modifiable Units of item swapping From ' + strErrorMessage;
              this.noError = false;
            }
            if (this.noError) {
              var postData = {
                eaSwapItems: this.globalKey.Values,
                accountNumber: this.accountNo,
                cropYear: this.cropYear,
                companyCode: this.companyCode
              };

              this.subscription.push(this.dealerService.eaSwapUpdateOrder(postData)
                .subscribe(result => {
                  if (result && result.status == true) {
                    this.toastrService.success('EA Order # ' + postData.eaSwapItems[0].fromProduct.dealerOrderNumber + ' has been successfully Updated.');
                    this.eaSwapProductSliderModelService.close();
                    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
                    this.router.navigate(['/orders/dealer-order-view', 0, this.dealerOrderId, this.accountNo]);
                  }
                }, (error => {
                  this.loaderService.setLoaderStatus(false);
                })));
            }
            else {
              this.toastrService.error(strErrorMessage);
              this.loaderService.setLoaderStatus(false);
            }
          }
        }, (error => {
          this.loaderService.setLoaderStatus(false);
        })));
    }
    else {
      this.toastrService.warning('No item to update');
    }
  }

  // Line item validation
  validateLineItem(item: any) {
    this.totalSum = 0;
    this.eaSwapProductDS.forEach(x => {
      if (x.swapEAUnits > 0) {
        this.totalSum += +x.swapEAUnits;
      }
    });

    if (+item.swapEAUnits < 0) {
      item.swapEAUnits = 0;
    }

    if (item.swapEAUnits != 0 && item.swapEAUnits % item.conv != 0 && item.conv > 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(
        (y) => y.id != 'conv'
      );
      item.lineErrors.errors.push({
        id: 'conv',
        error: 'Please re-enter SWAP EA Units in multiples of ' + item.conv,
      });
      item.lineErrors.itemId = item.itemID;
    } else {
      item.lineErrors.errors = item.lineErrors.errors.filter(
        (y) => y.id != 'conv'
      );
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemID;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (this.totalSum > this.fromProduct.eaModifiableUnits && +item.swapEAUnits > 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(
        (y) => y.id != 'netSwap'
      );
      item.lineErrors.errors.push({
        id: 'netSwap',
        error: 'Swap EA Units should be Less/Equal to the EA Modifiable Units of item swapping From',
      });
      item.lineErrors.itemId = item.itemID;
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(
        (y) => y.id != 'netSwap'
      );
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === item.itemID;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs.push(item.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }

    return item;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    } else {
      this.showErrorBlock = false;
    }
  }

  cancelEaSwap() {
    this.eaSwapProductSliderModelService.close();
  }

  //ngAfterViewInit
  ngAfterViewInit(): void {
  }
}

export class LineError {
  itemId: number;
  errors: Array<string> = [];
}
